import { forIn, forEach, get, isArray } from 'lodash-es';

/**
 * Installs components
 *
 * @param Vue
 * @param c
 */
const components = (Vue, c) => {
  forIn(c, (v, k) => {
    Vue.component(k, v);
  });
};

/**
 * Installs directives
 *
 * @param Vue
 * @param d
 */
const directives = (Vue, d) => {
  forIn(d, (v, k) => {
    Vue.directive(k, v);
  });
};

/**
 * Installs filters
 *
 * @param Vue
 * @param f
 */
const filters = (Vue, f) => {
  forIn(f, (v, k) => {
    Vue.filter(k, v);
  });
};

/**
 * Installs properties
 *
 * @param Vue
 * @param p
 */
const properties = (Vue, p) => {
  forIn(p, (v, k) => {
    /* eslint-disable no-param-reassign */
    Vue.prototype[k] = v;
    Object.defineProperty(Vue, k, { get: () => v });
  });
};

/**
 * Installs plugins
 *
 * @param Vue
 * @param pl
 */
const use = (Vue, pl) => {
  forEach(pl, (p) => {
    if (isArray(p)) {
      Vue.use(get(p, '[0]'), get(p, '[1]'));
    } else {
      Vue.use(p);
    }
  });
};

/**
 * Export interface
 */
export {
  filters,
  properties,
  directives,
  components,
  use,
};



// WEBPACK FOOTER //
// ./src/framework/index.js